// TODO: concept is this - a tent has r rooms and a room has c capacity
// for example, a family room tent has 4 rooms and each room has 4 people = 16 capacity,
// but there are 15 family room tents = total of 15 * 4 = 60 rooms.

export type CapacityCount = number & { __capacityCount: never };
export type RoomCount = number & { __roomCount: never };

export const capacityCount = (count: number) => count as CapacityCount;
export const roomCount = (count: number) => count as RoomCount;
